export default function MessageDSLOnly(dsl: string) {
  return `(and (equal type "message") ${dsl})`;
}
